/**
 * A module: one piece of the shell that a preset places in a slot (chat, main bar, content…).
 * It knows nothing about where it is; it fills the box it is given. Like a widget it can have
 * several looks (`variants`): which one the theme, the preset or Settings chose
 * (`appearance.moduleVariants`), else the standard one.
 */
import type { ComponentType } from 'react';

export interface ModuleVariant {
  id: string;
  /** i18n key, shown in Settings. */
  label: string;
  Component: ComponentType;
}

export interface ModuleDefinition {
  id: string;
  /** i18n key, for the layout editor and Settings. */
  label: string;
  /** Something a hand touches: motor mode keeps it within reach. */
  interactive: boolean;
  /** A bar that runs edge to edge (top bar, main bar, status): its background is not inset by the screen
   *  margin, its content is (it reads --frame-padding in its own padding). */
  fullBleed?: boolean;
  /** The standard look. */
  Component: ComponentType;
  /** Other looks. */
  variants?: ModuleVariant[];
}

export const STANDARD_MODULE_VARIANT = 'standard';

export function moduleVariantsOf(def: ModuleDefinition): ModuleVariant[] {
  return [{ id: STANDARD_MODULE_VARIANT, label: 'module.variant.standard', Component: def.Component }, ...(def.variants ?? [])];
}

export function pickModuleVariant(def: ModuleDefinition, wanted: string | undefined): ModuleVariant {
  const all = moduleVariantsOf(def);
  return all.find((v) => v.id === wanted) ?? all[0]!;
}
